module.exports = __webpack_public_path__ + "img/jitingquanxinxi001.95966674.png";